import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import logo from "../assets/logo.png";

const Invoice = () => {

  const { id } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {

    fetch(`/api/invoice/${id}`)
      .then(res => res.json())
      .then(res => setData(res))
      .catch(err => console.error(err));

  }, [id]);

  const num = (v) => {
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };

  if (!data) {
    return (
      <p className="p-10">
        Loading...
      </p>
    );
  }

  const {
  rental,
  items
} = data;

  const billHistory = data.billHistory || [];

  const paymentHistory = data.paymentHistory || [];
  const summary =
  data.financialSummary || {};
  console.log("Financial Summary:", summary);
console.log("Total Discount:", summary.totalDiscount);

  const recoveryRefunds =
  data.recoveryRefunds || [];

  const isCredit = rental.rental_type === "credit";

  // =========================================
  // PRODUCT RENT TOTAL (per-item days x rate x qty)
  // =========================================

  const itemRows = items.map(item => {

    const start = new Date(
      item.start_date || rental.rent_date
    );

    const end = new Date(
      item.end_date || rental.return_date
    );

    let days = Math.ceil(
      (end - start) / (1000 * 60 * 60 * 24)
    ) + 1;

    if (isNaN(days) || days <= 0) days = 1;

    const total = days * num(item.price) * num(item.quantity);

    return { ...item, days, total };
  });

  const productRentTotal = itemRows.reduce(
    (s, it) => s + it.total,
    0
  );

  const totalCollected =
    num(rental.paid_amount) ||
    paymentHistory.reduce((s, p) => s + num(p.amount), 0);




  const billHistoryTotal =
  billHistory.reduce(
    (sum, row) =>
      sum + num(row.change_amount),
    0
  );

const finalCreditBill =
  billHistoryTotal +
  num(rental.labour_charges) +
  num(rental.transport_charges) +
  num(summary.lostCharges) +
  num(summary.damageCharges) ;
  return (

    <>

      <div className="min-h-screen bg-gray-200 p-6 print-area">

        {/* ===================== BILL SHEET ===================== */}

        <div className="max-w-3xl mx-auto bg-white border-[3px] border-indigo-900 p-6 text-indigo-950">

          {/* HEADER : logo (left) | business (center) | phone (right) */}

          <div className="flex items-center gap-4 border-b-2 border-indigo-900 pb-4">

            <img
              src={logo}
              alt="Logo"
              style={{ filter: "grayscale(0%)" }}
              className="w-40 h-40 object-contain shrink-0"
            />

            <div className="flex-1 text-center">

              <p className="text-sm">॥ श्री ॥</p>

              <h1 className="text-3xl font-bold tracking-wide">
                सुनंदा मंगल केंद्र
              </h1>

              <p className="text-xs mt-1 leading-5">
               २६३, शुक्रवार पेठ, मिरामाता चौक, चिंचेची तालीम जवळ, पुणे – ४११ ००२
              </p>

            </div>

            <div className="text-right text-xs shrink-0 w-24">
              <p>☎</p>
              <p>9822336632</p>
              <p>7020571358</p>
            </div>

          </div>

          {/* META : customer (To) | number + date */}

          <div className="flex border-b-2 border-indigo-900">

            <div className="flex-1 border-r-2 border-indigo-900 p-3 text-sm">
              <p className="font-semibold">प्रती / To:</p>
              <p className="mt-1">
                {rental.first_name} {rental.last_name}
              </p>
              <p>{rental.phone}</p>
              <p>{rental.address || "-"}</p>
            </div>

            <div className="w-56 p-3 text-sm">
              <p>
                <span className="font-semibold">नंबर / No:</span>{" "}
                #{rental.id}
              </p>
              <p className="mt-1">
                <span className="font-semibold">दि. / Date:</span>{" "}
                {formatDate(rental.rent_date)}
              </p>
              <p className="mt-1">
                <span className="font-semibold">Return:</span>{" "}
                {formatDate(rental.return_date)}
              </p>
              <p className="mt-1">
                <span className="font-semibold">Type:</span>{" "}
                {isCredit ? "Credit" : "Regular"}
              </p>
              <div
  className={`mt-2 inline-block px-3 py-1 rounded-full text-xs font-bold

  ${
    rental.payment_status === "paid"
      ? "bg-green-100 text-green-700"
      : rental.payment_status === "partial"
      ? "bg-yellow-100 text-yellow-700"
      : "bg-red-100 text-red-700"
  }`}
>

  {(rental.payment_status || "unpaid").toUpperCase()}

</div>
            </div>

          </div>

          {/* PRODUCTS TABLE */}

          <table className="w-full border-collapse text-sm">

            <thead>
              <tr className="bg-indigo-50">
                <th className="border border-indigo-900 p-2 w-10">अ.क्र.</th>
                <th className="border border-indigo-900 p-2 text-left">मालाचे वर्णन / Description</th>
                <th className="border border-indigo-900 p-2 w-16">संख्या</th>
                <th className="border border-indigo-900 p-2 w-16">दर</th>
                <th className="border border-indigo-900 p-2 w-16">Days</th>
                <th className="border border-indigo-900 p-2 w-24">एकूण</th>
              </tr>
            </thead>

            <tbody>

              {itemRows.map((item, i) => (
                <tr key={item.id}>
                  <td className="border border-indigo-900 p-2 text-center">
                    {i + 1}
                  </td>
                  <td className="border border-indigo-900 p-2">
                    {item.name}
                  </td>
                  <td className="border border-indigo-900 p-2 text-center">

  <div>
    {item.quantity}
  </div>

  <div className="text-xs text-gray-500">
    Returned: {item.returned_quantity || 0}
  </div>

  <div className="text-xs text-gray-500">
    Lost: {item.lost_quantity || 0}
  </div>

</td>
                
                  <td className="border border-indigo-900 p-2 text-center">
                    ₹{item.price}
                  </td>
                  <td className="border border-indigo-900 p-2 text-center">
                    {item.days}
                  </td>
                  <td className="border border-indigo-900 p-2 text-right">
                    ₹{item.total}
                  </td>
                </tr>
              ))}

              <tr className="font-semibold bg-indigo-50">
                <td
                  colSpan="5"
                  className="border border-indigo-900 p-2 text-right"
                >
                  Product Rent Total
                </td>
                <td className="border border-indigo-900 p-2 text-right">
                  ₹{productRentTotal}
                </td>
              </tr>

            </tbody>

          </table>

          {/* BILLING HISTORY (full lifecycle ledger) */}

          

        

{/* ================= ORIGINAL BILLING ================= */}

<div className="mt-6">

  <h3 className="font-semibold mb-2 text-lg">
  Initial Billing
  </h3>
  <p className="text-xs text-gray-500 mb-2">
  Original rental invoice details
</p>

  <table className="w-full border-collapse text-sm">

    <tbody>

      <tr>
        <td className="border border-indigo-900 p-2">
          Original Product Rent
        </td>
        <td className="border border-indigo-900 p-2 text-right">
          ₹{Number(rental.original_rental_amount || 0)}
        </td>
      </tr>

      <tr>
        <td className="border border-indigo-900 p-2">
          Labour Charges
        </td>
        <td className="border border-indigo-900 p-2 text-right">
          ₹{Number(rental.labour_charges || 0)}
        </td>
      </tr>

      <tr>
        <td className="border border-indigo-900 p-2">
          Transport Charges
        </td>
        <td className="border border-indigo-900 p-2 text-right">
          ₹{Number(rental.transport_charges || 0)}
        </td>
      </tr>

      {!isCredit && (
<tr>
  <td className="border border-indigo-900 p-2">
    Security Deposit
  </td>

  <td className="border border-indigo-900 p-2 text-right">
    ₹{Number(rental.deposit || 0)}
  </td>
</tr>
)}

      <tr className="bg-indigo-50 font-bold">

        <td className="border border-indigo-900 p-2">
         {isCredit ? "Initial Collection" : "Grand Collected"}
        </td>

        <td className="border border-indigo-900 p-2 text-right">

          ₹{
            Number(rental.original_rental_amount || 0)
            +
            Number(rental.labour_charges || 0)
            +
            Number(rental.transport_charges || 0)
            +
            Number(rental.deposit || 0)
          }

        </td>

      </tr>

    </tbody>

  </table>

</div>

<div className="mt-6">

  <h3 className="font-semibold mb-2 text-lg">
    Settlement Adjustments
  </h3>

  <p className="text-xs text-gray-500 mb-2">
    Detailed rental modifications and deductions
  </p>

  <table className="w-full border-collapse text-sm">

    <thead>

      <tr className="bg-indigo-50">

        <th className="border border-indigo-900 p-2">
          Date
        </th>

        <th className="border border-indigo-900 p-2">
          Type
        </th>

        <th className="border border-indigo-900 p-2">
          Product
        </th>

        <th className="border border-indigo-900 p-2">
          Description
        </th>

        <th className="border border-indigo-900 p-2">
          Amount
        </th>

      </tr>

    </thead>

    <tbody>

     {billHistory
  .filter(row => row.type !== "discount")
  .map(row => (

        <tr key={row.id}>

          <td className="border border-indigo-900 p-2">
            {formatDate(
              row.entry_date ||
              row.created_at
            )}
          </td>

          <td className="border border-indigo-900 p-2 capitalize">
            {row.type}
          </td>

          <td className="border border-indigo-900 p-2">
            {row.name || "-"}
          </td>

          <td className="border border-indigo-900 p-2">
            {row.description}
          </td>

          <td className="border border-indigo-900 p-2 text-right">
            {num(row.change_amount) >= 0 ? "+" : "-"}
            ₹{Math.abs(num(row.change_amount))}
          </td>

        </tr>

      ))}

      {num(summary.lostCharges) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      -
    </td>

    <td className="border border-indigo-900 p-2">
      Lost
    </td>

    <td className="border border-indigo-900 p-2">
      All Products
    </td>

    <td className="border border-indigo-900 p-2">
      Lost Product Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      ₹{num(summary.lostCharges)}
    </td>
  </tr>
)}

{num(summary.damageCharges) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      -
    </td>

    <td className="border border-indigo-900 p-2">
      Damage
    </td>

    <td className="border border-indigo-900 p-2">
      All Products
    </td>

    <td className="border border-indigo-900 p-2">
      Damage Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      ₹{num(summary.damageCharges)}
    </td>
  </tr>
)}
    </tbody>

  </table>

</div>
<div className="mt-6">

  <h3 className="font-semibold mb-2 text-lg">
    Financial Summary
  </h3>

  {!isCredit ? (

    <table className="w-full border-collapse text-sm">

      <tbody>

        <tr>
          <td className="border border-indigo-900 p-2">
            Security Deposit
          </td>

          <td className="border border-indigo-900 p-2 text-right">
            ₹{num(summary.deposit)}
          </td>
        </tr>

        {num(summary.totalReductions) > 0 && (
          <tr>
            <td className="border border-indigo-900 p-2">
              Rental Reductions
            </td>

            <td className="border border-indigo-900 p-2 text-right text-green-700">
              +₹{num(summary.totalReductions)}
            </td>
          </tr>
          
        )}
        {num(summary.totalAddedProductRent) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      Added Product Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      -₹{num(summary.totalAddedProductRent)}
    </td>
  </tr>
)}

{num(summary.totalAddedTransport) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      Added Transport Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      -₹{num(summary.totalAddedTransport)}
    </td>
  </tr>
)}

{num(summary.totalAddedLabour) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      Added Labour Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      -₹{num(summary.totalAddedLabour)}
    </td>
  </tr>
)}
{num(summary.totalAdditionalCharges) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2">
      Additional Charges
    </td>

    <td className="border border-indigo-900 p-2 text-right text-red-700">
      -₹{num(summary.totalAdditionalCharges)}
    </td>
  </tr>
)}

        {num(summary.totalExtensions) > 0 && (
          <tr>
            <td className="border border-indigo-900 p-2">
              Rental Extensions
            </td>

            <td className="border border-indigo-900 p-2 text-right text-red-700">
              -₹{num(summary.totalExtensions)}
            </td>
          </tr>
        )}

        {num(summary.lostCharges) > 0 && (
          <tr>
            <td className="border border-indigo-900 p-2">
              Lost Product Charges
            </td>

            <td className="border border-indigo-900 p-2 text-right text-red-700">
              -₹{num(summary.lostCharges)}
            </td>
          </tr>
        )}

        {num(summary.damageCharges) > 0 && (
          <tr>
            <td className="border border-indigo-900 p-2">
              Damage Charges
            </td>

            <td className="border border-indigo-900 p-2 text-right text-red-700">
              -₹{num(summary.damageCharges)}
            </td>
          </tr>
        )}
        {num(summary.totalDiscount) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2 font-semibold text-green-700">
      Discount
    </td>

    <td className="border border-indigo-900 p-2 text-right font-semibold text-green-700">
      -₹{num(summary.totalDiscount)}
    </td>
  </tr>
)}

       {Number(rental.settlement_done) !== 1 ? (

  <tr className="bg-yellow-50">

    <td className="border border-indigo-900 p-3 font-bold text-yellow-700">
      Expected Settlement
    </td>

    <td className="border border-indigo-900 p-3 text-right font-bold text-yellow-700">

      {num(summary.expectedSettlement) < 0
        ? `Customer Pays ₹${Math.abs(num(summary.expectedSettlement))}`
        : `Refund ₹${num(summary.expectedSettlement)}`}

    </td>

  </tr>

) : num(summary.settlementAmount) > 0 ? (

  <tr className="bg-green-50">

    <td className="border border-indigo-900 p-3 font-bold text-green-700">
      Refund Amount
    </td>

    <td className="border border-indigo-900 p-3 text-right font-bold text-xl text-green-700">
      ₹{num(summary.settlementAmount)}
    </td>

  </tr>

) : num(summary.settlementAmount) < 0 ? (

  <tr className="bg-red-50">

    <td className="border border-indigo-900 p-3 font-bold text-red-700">
      Customer Pays Extra
    </td>

    <td className="border border-indigo-900 p-3 text-right font-bold text-xl text-red-700">
      ₹{Math.abs(num(summary.settlementAmount))}
    </td>

  </tr>

) : (

  <tr className="bg-gray-50">

    <td className="border border-indigo-900 p-3 font-bold">
      Settlement Complete
    </td>

    <td className="border border-indigo-900 p-3 text-right font-bold text-xl">
      ₹0
    </td>

  </tr>

)}

      </tbody>

    </table>

  ) : (

    <table className="w-full border-collapse text-sm">

      <tbody>
{num(summary.totalDiscount) > 0 && (
  <tr>
    <td className="border border-indigo-900 p-2 font-semibold text-green-700">
      Discount
    </td>

    <td className="border border-indigo-900 p-2 text-right font-semibold text-green-700">
      -₹{num(summary.totalDiscount)}
    </td>
  </tr>
)}

<tr>
  <td className="border border-indigo-900 p-2">
    Final Bill Amount
  </td>

  <td className="border border-indigo-900 p-2 text-right font-bold">
    ₹{finalCreditBill}
  </td>
</tr>
        <tr>
          <td className="border border-indigo-900 p-2">
            Amount Paid
          </td>

          <td className="border border-indigo-900 p-2 text-right text-green-700">
            ₹{num(rental.paid_amount)}
          </td>
        </tr>

        <tr>
          <td className="border border-indigo-900 p-2">
            Pending Amount
          </td>

          <td className="border border-indigo-900 p-2 text-right text-red-700">
            ₹{num(rental.pending_amount)}
          </td>
        </tr>

        <tr className="bg-indigo-50">
          <td className="border border-indigo-900 p-3 font-bold">
            Payment Status
          </td>

          <td className="border border-indigo-900 p-3 text-right font-bold">
            {(rental.payment_status || "unpaid").toUpperCase()}
          </td>
        </tr>

      </tbody>

    </table>

  )}

  {!isCredit && summary.settlementDone === 1 && (

  <div className="mt-4 border border-green-300 bg-green-50 p-4 rounded">

    {num(summary.depositReturned) > 0 ? (

      <>
        <p className="font-bold text-green-700">
          Refund Completed
        </p>

        <p className="text-green-700">
          Amount Refunded:
          ₹{num(summary.depositReturned)}
        </p>
      </>

    ) : num(summary.settlementAmount) < 0 ? (

      <>
        <p className="font-bold text-red-700">
          Settlement Completed
        </p>

        <p className="text-red-700">
          Customer Paid:
          ₹{Math.abs(num(summary.settlementAmount))}
        </p>
      </>

    ) : (

      <>
        <p className="font-bold text-green-700">
          Settlement Completed
        </p>

        <p className="text-gray-700">
          No refund or extra payment required.
        </p>
      </>

    )}

  </div>

)}

</div>
{isCredit && paymentHistory.length > 0 && (

<div className="mt-6">

  <h3 className="font-semibold mb-2 text-lg">
    Payment History
  </h3>

  <table className="w-full border-collapse text-sm">

    <thead>

      <tr className="bg-indigo-50">

        <th className="border border-indigo-900 p-2">
          Date
        </th>

        <th className="border border-indigo-900 p-2">
          Amount
        </th>

      </tr>

    </thead>

    <tbody>

      {paymentHistory.map(payment => (

        <tr key={payment.id}>

          <td className="border border-indigo-900 p-2">
            {formatDate(payment.payment_date)}
          </td>

          <td className="border border-indigo-900 p-2 text-right">
            ₹{payment.amount}
          </td>

        </tr>

      ))}

    </tbody>

  </table>

</div>

)}

{recoveryRefunds.length > 0 && (

<div className="mt-6">

  <h3 className="font-semibold mb-2 text-lg">
    Lost Product Recovery
  </h3>

  <p className="text-xs text-gray-500 mb-2">
    Products recovered after settlement and refund status
  </p>

  <table className="w-full border-collapse text-sm">

    <thead>

      <tr className="bg-indigo-50">

        <th className="border border-indigo-900 p-2">
          Date
        </th>

        <th className="border border-indigo-900 p-2">
          Product
        </th>

        <th className="border border-indigo-900 p-2">
          Qty
        </th>

        <th className="border border-indigo-900 p-2">
          Refund
        </th>

        <th className="border border-indigo-900 p-2">
          Status
        </th>

      </tr>

    </thead>

    <tbody>

      {recoveryRefunds.map(row => (

        <tr key={row.id}>

          <td className="border border-indigo-900 p-2">
            {formatDate(row.recovered_date)}
          </td>

          <td className="border border-indigo-900 p-2">
            {row.product_name}
          </td>

          <td className="border border-indigo-900 p-2 text-center">
            {row.recovered_quantity}
          </td>

          <td className="border border-indigo-900 p-2 text-right">
            ₹{num(row.amount)}
          </td>

          <td
            className={`border border-indigo-900 p-2 text-center font-semibold ${
              row.paid
                ? "text-green-700"
                : "text-orange-600"
            }`}
          >
            {row.paid ? "Paid" : "Pending"}
          </td>

        </tr>

      ))}

    </tbody>

  </table>

</div>

)}

          {/* FOOTER */}

          <div className="flex justify-between items-end mt-10 text-sm">
            <div>
              <p>रविवार बंद</p>
              <p className="mt-6">सही __________</p>
            </div>
            <div className="font-semibold">
              सुनंदा मंगल केंद्र करिता
            </div>
          </div>

        </div>

        {/* PRINT */}

        <div className="text-center mt-6 print:hidden">
          <button
            onClick={() => window.print()}
            className="bg-indigo-900 text-white px-6 py-3 rounded"
          >
            Print Invoice
          </button>
        </div>

      </div>

      <style>
        {`
        @media print {
          body * { visibility: hidden; }
          .print-area, .print-area * { visibility: visible; }
          .print-area {
            position: absolute;
            left: 0; top: 0;
            width: 100%;
            background: white;
            padding: 0;
          }
        }
        `}
      </style>

    </>
  );
};

export default Invoice;
